import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { Icon } from '../Icon';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export const Dialog = ({ title, children, className, open, onClose, ...rest }) => {
    const t = useLocales();
    if (!open)
        return null;
    return (_jsxs("dialog", { className: classnames(styles.dialog, className), open: true, ...rest, children: [_jsxs("div", { className: styles.header, children: [_jsx("div", { className: styles.title, children: title }), _jsx("button", { className: styles.closeButton, onClick: onClose, "aria-label": t('Close'), children: _jsx(Icon, { type: "delete", size: 32 }) })] }), _jsx("div", { className: styles.body, children: children })] }));
};
